















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxLookup, DxScrollView } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import DataSource from 'devextreme/data/data_source';
import dxCustomStore from 'devextreme/data/custom_store';
import { MailConfig } from '@/installationConfig';

import { DxForm, DxSimpleItem, DxRequiredRule, DxEmailRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import {
  ContactsClient,
  ContactsLookupQuery,
  CreditNotesClient,
  DataSourceLoadOptionsBase,
  IContactListItemDto,
  IMailCreditNoteCommand,
  IMailTemplateDto,
  MailCreditNoteCommand,
  MailTemplatesClient,
  MailTemplateType,
  ProjectContactsClient,
  CreditNoteDto,
} from '@/data/web-api-client';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxLabel,
    DxLookup,
    DxScrollView,
    DxRequiredRule,
    DxEmailRule,
    DxHtmlEditor,
  },
})
export default class CreditNoteMailPopup extends Vue {
  private show: boolean = false;
  private sending: boolean = false;
  private formdata: IMailCreditNoteCommand | any = {
    template: null,
    from: '',
    to: [],
    cc: [],
    subject: '',
    content: '',
    objectId: '',
  };
  private templates: IMailTemplateDto[] = [];

  @Prop({ required: true })
  private creditNote!: CreditNoteDto;

  public async open() {
    this.formdata.to.splice(0, this.formdata.to.length);
    this.formdata.cc.splice(0, this.formdata.cc.length);
    this.loadProjectContacts();

    if (this.creditNote.customerContact && this.creditNote.customerContact.email && this.creditNote.customerContact.email !== '') {
      (this.formdata.to as string[]).push(this.creditNote.customerContact.email);
    } else if (this.creditNote.customer && this.creditNote.customer.email && this.creditNote.customer.email !== '') {
      (this.formdata.to as string[]).push(this.creditNote.customer.email);
    }

    this.formdata.objectId = this.creditNote.id;

    const lastUsedEmail = localStorage.getItem('creditnote_last_used_email');
    const lastUsedTemplate = localStorage.getItem('creditnote_last_used_template');
    if (lastUsedEmail) {
      this.formdata.from = lastUsedEmail;
    } else {
      this.formdata.from = this.currentUser.username;
    }

    if (lastUsedTemplate) {
      this.formdata.template = lastUsedTemplate;
      const template = this.templates.find((o) => o.name === lastUsedTemplate);
      if (template) {
        this.formdata.subject = template.subject ? template.subject : '';
        this.formdata.content = template.content ? template.content : '';
        this.replaceTags();
      }
    }

    this.show = true;
  }

  private async loadProjectContacts() {
    if (!this.creditNote.projectId || this.creditNote.projectId === '') {
      return;
    }

    const res = await new ProjectContactsClient(undefined, this.$axios).getContacts(this.creditNote.projectId);
    res.forEach((contact) => {
      if (contact.sendInvoice && contact.contact && contact.contact.email && contact.contact.email !== '') {
        if (this.formdata.to.indexOf(contact.contact.email) === -1) {
          this.formdata.to.push(contact.contact.email);
        }
      }
    });
  }

  private replaceTags() {
    try {
      let contact = null;
      if (this.creditNote) {
        if (this.creditNote.customerContact) {
          contact = this.creditNote.customerContact;
        } else if (this.creditNote.customer) {
          contact = this.creditNote.customer;
        }
      }

      while (this.formdata.content.indexOf('#Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Name', contact ? contact.displayName : '');
      }

      while ((this.formdata.content as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#DocumentNumber', this.creditNote.documentNumber);
      }

      while ((this.formdata.subject as string).indexOf('#DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#DocumentNumber', this.creditNote.documentNumber);
      }

      if (contact && contact.type === 'Contact') {
        const splittedName = contact.displayName ? contact.displayName.split(' ') : null;
        if (splittedName && splittedName.length > 0) {
          const firstname = splittedName[0];
          const lastname = contact.displayName!.replace(firstname, '');

          while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Firstname', firstname);
          }

          while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
            this.formdata.content = this.formdata.content.replace('#Contact_Lastname', lastname);
          }
        }
      }

      while (this.formdata.content.indexOf('#Contact_Firstname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Firstname', '');
      }

      while (this.formdata.content.indexOf('#Contact_Lastname') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Contact_Lastname', '');
      }

      while (this.formdata.content.indexOf('#Project_Name') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_Name', this.creditNote.projectName);
      }
      while (this.formdata.subject.indexOf('#Project_Name') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_Name', this.creditNote.projectName);
      }

      while (this.formdata.subject.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.subject = this.formdata.subject.replace('#Project_DocumentNumber', this.creditNote.projectNumber);
      }

      while (this.formdata.content.indexOf('#Project_DocumentNumber') !== -1) {
        this.formdata.content = this.formdata.content.replace('#Project_DocumentNumber', this.creditNote.projectNumber);
      }
    } catch {
      // do nothing
    }
  }

  async created() {
    try {
      this.templates = await new MailTemplatesClient(undefined, this.$axios).getAll(MailTemplateType.CreditNote);
    } catch {
      // do nothing
    }
  }

  async send() {
    try {
      const form: any = this.$refs.form;
      const validationResult = form.instance.validate();

      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      this.sending = true;

      if (this.formdata.from) {
        localStorage.setItem('creditnote_last_used_email', this.formdata.from);
        localStorage.setItem('creditnote_last_used_template', this.formdata.template);
      }

      // TO KEEP MAIL FORMAT CORRECT, REPLACE P-TAG WITH DIV-TAG
      this.formdata.content = this.formdata.content.replaceAll('<p>', '<div>').replaceAll('</p>', '</div>');
      await new CreditNotesClient(undefined, this.$axios).mail(new MailCreditNoteCommand(this.formdata));
      notificationService.showSuccessMessage('Mail verstuurd');
      this.show = false;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.sending = false;
    }
  }

  get currentUser() {
    return this.$store.getters.currentUser;
  }

  get templateLookupOptions() {
    const self = this;
    return {
      dataSource: this.templates,
      displayExpr: 'name',
      valueExpr: 'name',
      onItemClick: (e: any) => {
        self.formdata.subject = e.itemData.subject;
        self.formdata.content = e.itemData.content;
        self.formdata.language = e.itemData.language;

        self.replaceTags();
      },
    };
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }

  get contactDataSource() {
    const client = new ContactsClient(undefined, this.$axios);
    return new DataSource({
      store: new dxCustomStore({
        key: 'id',
        load: async (loadOptions) => {
          if (loadOptions.filter) {
            loadOptions.filter = undefined;
          }
          if (loadOptions.searchExpr && loadOptions.searchOperation && loadOptions.searchValue) {
            loadOptions.filter = [['displayName', loadOptions.searchOperation, loadOptions.searchValue], 'or', ['email', loadOptions.searchOperation, loadOptions.searchValue]];
          }

          const res = await client.lookupContacts(
            new ContactsLookupQuery({
              projectId: this.creditNote.projectId,
              options: new DataSourceLoadOptionsBase(
                Object.assign({}, loadOptions, {
                  stringToLower: true,
                })
              ),
            })
          );

          return res;
        },
        byKey: async (val: string) => {
          return await client.getBasicInfo(val);
        },
      }),
      paginate: this.creditNote.projectId ? false : true,
    });
  }

  get contactOptions() {
    return {
      dataSource: this.contactDataSource,
      searchEnabled: true,
      remoteOperations: true,
      searchExpr: ['email', 'displayName'],
      acceptCustomValue: true,
      valueExpr: (item: any) => {
        if (!item) {
          return 'undefined';
        }

        if (typeof item === 'string') {
          return item;
        }

        return item.email;
      },
      displayExpr: (val: IContactListItemDto | string) => {
        if (!val) {
          return '';
        }

        if (typeof val === 'string') {
          return val;
        }

        if (!val.displayName) {
          return val.email;
        }
        return `${val.displayName} <${val.email}>`;
      },
      onCustomItemCreating: (args: any) => {
        args.customItem = args.text;
      },
    };
  }

  get fromOptions() {
    return {
      dataSource: [
        MailConfig.infoMailAddress,
        MailConfig.accountingMailAddress,
        MailConfig.executionMailAddress,
        MailConfig.invoicingMailAddress,
        MailConfig.calculationMailAddress,
        this.currentUser.username,
      ],
    };
  }
}
